<script>
import gaFilterComponentMixin from '@mixins/gaFilterComponentMixin';
import GaBaseExpandedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseExpandedFilter.vue';
import GaBaseFoldedFilter from '@components/v2/filter/sidebarFilters/parts/GaBaseFoldedFilter.vue';
import RadioButton from 'primevue/radiobutton';
import AkCalendar from '@components/v2/input/AkCalendar.vue';
import moment from 'moment';

export default {
  name: 'RmFilterDatePeriods',
  components: {AkCalendar, GaBaseFoldedFilter, GaBaseExpandedFilter, RadioButton},
  mixins: [gaFilterComponentMixin],
  data() {
    return {
      selectedOption: null,
      customStart: null,
      customEnd: null,
    };
  },
  computed: {
    periodOptions() {
      return [
        {value: 'yearToDate', label: 'Année à ce jour'},
        {value: 'currentYear', label: 'Année en cours'},
        {value: 'currentMonth', label: 'Mois en cours'},
        {value: 'nextMonth', label: 'Mois suivant'},
        {value: 'previousMonth', label: 'Mois précédent'},
        {value: 'next3Months', label: '3 prochains mois'},
        {value: 'custom', label: 'Période personnalisée'},
      ];
    },
    isCustom() {
      return this.selectedOption === 'custom';
    },
    subtitle() {
      const opt = this.periodOptions.find((o) => o.value === this.selectedOption);
      if (opt) return opt.label;
      const labels = this.currentValue?.labels;
      if (labels?.length) return labels[0];
      return 'Tout';
    },
    nbSelected() {
      return null;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.currentFilter.value = this.currentValue?.value ? {...this.currentValue.value} : null;
      this.currentFilter.labels = this.currentValue?.labels ? [...this.currentValue.labels] : [];
      this.selectedOption = this.currentValue?.value?.periodView ?? null;
      this.customStart = this.currentValue?.value?.period?.[0] ?? null;
      this.customEnd = this.currentValue?.value?.period?.[1] ?? null;
    },
    initLabels() {},
    computePeriod() {
      switch (this.selectedOption) {
        case 'yearToDate':
          return [moment().startOf('year').toDate(), new Date()];
        case 'currentYear':
          return [moment().startOf('year').toDate(), moment().endOf('year').toDate()];
        case 'currentMonth':
          return [moment().startOf('month').toDate(), moment().endOf('month').toDate()];
        case 'nextMonth':
          return [moment().add(1, 'month').startOf('month').toDate(), moment().add(1, 'month').endOf('month').toDate()];
        case 'previousMonth':
          return [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().subtract(1, 'month').endOf('month').toDate(),
          ];
        case 'next3Months':
          return [moment().startOf('month').toDate(), moment().add(2, 'months').endOf('month').toDate()];
        case 'custom':
          return [this.customStart, this.customEnd];
        default:
          return null;
      }
    },
    preApply() {
      if (!this.selectedOption) return;
      const period = this.computePeriod();
      if (!period || !period[0] || !period[1]) return;

      const opt = this.periodOptions.find((o) => o.value === this.selectedOption);
      this.currentFilter.value = {
        period,
        searchDate: new Date(),
        periodView: this.selectedOption,
        searchView: 'today',
        inlineSync: true,
      };
      this.currentFilter.labels = opt ? [opt.label] : [];
      this.apply();
    },
    clearFilter() {
      this.selectedOption = 'currentMonth';
      this.customStart = null;
      this.customEnd = null;
      const opt = this.periodOptions.find((o) => o.value === this.selectedOption);
      this.currentFilter.value = {
        period: this.computePeriod(),
        searchDate: new Date(),
        periodView: this.selectedOption,
        searchView: 'today',
        inlineSync: true,
      };
      this.currentFilter.labels = opt ? [opt.label] : [];
      this.currentValue = {...this.currentFilter};
    },
  },
};
</script>

<template>
  <template v-if="isVisible">
    <GaBaseFoldedFilter
      v-if="!isExpanded"
      title="Périodes"
      @click="onClick"
      :icon="hasIcon ? 'ga-calendar' : null"
      :subtitle="subtitle"
      :nb-selected="nbSelected" />
    <GaBaseExpandedFilter
      v-else
      title="Choisir les périodes"
      :nb-selected="nbSelected"
      :can-go-back="false"
      @apply="preApply"
      @reset="reset"
      @back="back">
      <div class="flex flex-col gap-2 px-8 py-6">
        <div v-for="option in periodOptions" :key="option.value" class="flex flex-col w-full gap-2">
          <label class="gap-3 flex px-2 py-1 items-center cursor-pointer">
            <RadioButton
              v-model="selectedOption"
              :value="option.value"
              class="[&_.p-radiobutton-box]:!border-grey [&_.p-radiobutton-icon]:rounded-full"
              :class="{
                '[&_.p-radiobutton-icon]:!bg-primary [&_.p-radiobutton-box]:!border-primary':
                  selectedOption === option.value,
              }" />
            <span class="font-medium text-grey-900 select-none">{{ option.label }}</span>
          </label>
          <div v-if="isCustom && option.value === 'custom'" class="flex gap-2 mb-3 px-4">
            <AkCalendar
              v-model="customStart"
              input-class="h-[56px]"
              placeholder="JJ/MM/AAAA"
              label="Du"
              icon="ga-icon ga-calendar" />
            <AkCalendar
              v-model="customEnd"
              input-class="h-[56px]"
              placeholder="JJ/MM/AAAA"
              label="Au"
              icon="ga-icon ga-calendar" />
          </div>
        </div>
      </div>
    </GaBaseExpandedFilter>
  </template>
</template>

<style scoped></style>
